import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PortalModule } from '@angular/cdk/portal';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DynamicModule } from 'ng-dynamic-component';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { AtwFrameCategoriesAdmin } from './frames/frame-categories/admin/frame-categories-admin/frame-categories-admin.component';
import { AtwFrameNewsGroupAdmin } from './frames/frame-news-group/admin/frame-news-group-admin/frame-news-group-admin.component';
import { AtwFrameProductsAdmin } from './frames/frame-products/admin/frame-products-admin/frame-products-admin.component';


// import { FrameMutilBlankAminComponent } from './frames/frame-mutil-blank/admin/frame-mutil-blank-admin/frame-mutil-blank-admin.component';
import { NgZorroAntModule } from 'vhobjects-service';
import { MaterialModule } from 'vhobjects-service';
import { AtwFrameFoodsAdmin } from './frames/frame-foods/admin/frame-foods-admin/frame-foods-admin.component';
import { AtwFrameNewsAdmin } from './frames/frame-news/admin/frame-news-admin/frame-news-admin.component';
import { AtwFrameServiceAdmin } from './frames/frame-service/admin/frame-service-admin/frame-service-admin.component';
import { AtwFrameRecruitmentAdmin } from './frames/frame-recruitment/admin/frame-recruitment-admin/frame-recruitment-admin.component';
import { AtwFrameWebsiteAdmin } from './frames/frame-website/admin/frame-website-admin/frame-website-admin.component';
// import { AtwFrameAppAdmin } from './frames/frame-app/admin/frame-app-admin/frame-app-admin.component';
import { TranslateModule } from '@ngx-translate/core';
import { AtwFrameRepeatAdmin } from './frames/frame-repeat/admin/frame-repeat-admin/frame-repeat-admin.component';
import { ColorPickerModule } from 'ngx-color-picker'; 
import { VhLanguagePipeModule } from './vh-language.pipe';
import { AtwFrameAppAdmin } from './frames/frame-app/admin/frame-app-admin/frame-app-admin.component';
import { SelectLanguageConfigModule } from './select-language-config/select-language-config.module';

let component = [
  AtwFrameCategoriesAdmin,
  AtwFrameNewsGroupAdmin,
  AtwFrameProductsAdmin,
  // FrameMutilBlankAminComponent,
  AtwFrameFoodsAdmin,
  AtwFrameNewsAdmin,
  AtwFrameServiceAdmin,
  AtwFrameRecruitmentAdmin,
  AtwFrameWebsiteAdmin,
  // AtwFrameAppAdmin,
  AtwFrameRepeatAdmin,
  
  AtwFrameAppAdmin

]; 

@NgModule({
  declarations: [component],
  entryComponents: [component],
  imports: [
    CommonModule,
    NgZorroAntModule,
    PortalModule,
    DragDropModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    DynamicModule,
    NgbCarouselModule,
    TranslateModule,
    ColorPickerModule,
    SelectLanguageConfigModule,
    VhLanguagePipeModule
  ],
  exports: [component],
})
export class FrameAdminComponentModule {}
